<template>
  <div></div>
</template>

<script>
import { hideLoading, showLoading } from '@/plugin/axios/loading'
import { ssoLogin } from '@/api/base'
import { setToken } from '@/util/util.ruquest'

export default {
  name: 'ssoCallback',
  data () {
    return {
      // ssoCode: ''
    }
  },
  mounted: function () {
    showLoading()
    const ssoCode = this.$route.query.code
    if (!ssoCode || ssoCode === '') {
      hideLoading()
      this.$router.push({
        name: 'login'
      })
    } else {
      ssoLogin(ssoCode).then(res => {
        setToken(res.data.accessToken, res.data.refreshToken)
        // const targetUri = this.$route.query.target_uri
        this.$router.replace('/')
      }).catch(err => {
        console.log(err)
        this.$router.push({
          name: 'login'
        })
      }).finally(() => hideLoading())
    }
  }
}
</script>

<style>
</style>
